<template>
    <div :class="contentWidth === 'boxed' ? 'container p-0' : null">
        <div class="auth-wrapper auth-v2">
            <b-row class="auth-inner m-0">

                <!-- Left Text-->
                <b-col lg="8" class="d-none d-lg-flex align-items-center p-5">
                    <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
                        <b-img fluid :src="imgUrl" alt="Login V2"/>
                    </div>
                </b-col>
                <!-- /Left Text-->

                <!-- Login-->
                <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5">
                    <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
                        <b-card-title title-tag="h2" class="font-weight-bold mb-1 text-center">
                            <b-img :src="companyLogo" class="logo-h" fluid/>
                        </b-card-title>
                        <router-view/>
                    </b-col>
                </b-col>
                <!-- /Login-->
            </b-row>
        </div>
    </div>
</template>

<script>
    import useAppConfig from '@vuexy/app-config/useAppConfig'
    import REST from "@/apliko/helpers/REST";

    export default {
        data() {
            return {
                imgUrl: '/vue/img/login-v2.svg',
              companyLogo: REST.storage('account/assets/', window.accountSettings.logo),
                logo: require(`@/assets/logo/logo-horizontal-light.png`)
            }
        },
        setup() {
            const {contentWidth} = useAppConfig()
            return {contentWidth}
        },
    }
</script>

<style lang="scss" scoped>

    .logo-h {
        max-height: 100px;
    }

    .brand-logo {
        img {
            max-height: 36px;
            opacity: 0.2;
        }
    }
    @import '~@vuexy/scss/vue/pages/page-auth.scss';
</style>



// WEBPACK FOOTER //
// src/layout/vuexy/custom/LayoutAuth.vue